import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface TipoNovedad {
  id?: number;
  codigo: string;
  descripcion: string;
  tipo: string;
  apartir_de: number;
  fecha_creacion?: string;
  usuario_creacion?: string;
  fecha_modificacion?: string;
  usuario_modificacion?: string;
  estado?: string;
  c_emp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocalTipoNovedadService {
  //private ENDPOINT = 'http://localhost:8000/tipo-novedad-comision';
  ENDPOINT = getEndpoint('coms_tipo_novedad_comision');

  constructor(private http: HttpClient) { }

  getAll(): Observable<TipoNovedad[]> {
    return this.http.get<TipoNovedad[]>(`${this.ENDPOINT}`);
  }

  getById(id: number, company: string): Observable<TipoNovedad> {
    return this.http.get<TipoNovedad>(`${this.ENDPOINT}/${company}/${id}`);
  }

  validateAndCreate(data: TipoNovedad, company: string): Observable<any> {
    return this.http.post(`${this.ENDPOINT}/validate-and-create`, data, {
      headers: { 'company': company }
    }).pipe(
      catchError((error) => {
        if (error.error && error.error.detail) {
          throw error;
        }
        throw error;
      })
    );
  } 

  validateAndUpdate(id: number, data: any, company: string): Observable<any> {
    return this.http.put(`${this.ENDPOINT}/validate-and-update/${id}`, data, {
      headers: { 'company': company }
    }).pipe(
      catchError((error) => {
        if (error.error && error.error.detail) {
          throw error;
        }
        throw error;
      })
    );
  }

  create(data: TipoNovedad, company: string): Observable<TipoNovedad> {
    return this.http.post<TipoNovedad>(`${this.ENDPOINT}/${company}`, data);
  }

  update(id: number, data: TipoNovedad, company: string): Observable<TipoNovedad> {
    return this.http.put<TipoNovedad>(`${this.ENDPOINT}/${company}/${id}`, data);
  }

  delete(id: number, usuario_modificacion: string, c_emp: string, company: string): Observable<any> {
    return this.http.delete(`${this.ENDPOINT}/${id}`, {
      headers: { 'company': company },
      params: { usuario_modificacion, c_emp }
    }).pipe(
      catchError((error) => {
        if (error.error && error.error.detail) {
          throw error;
        }
        throw error;
      })
    );
  }
}
